import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import CUSTOMER_SERVICE_PRODUCTS_QUERY, {
	type ProductsAppQuery,
} from '@atlassian/jira-relay/src/__generated__/ProductsAppQuery.graphql';

// /!\
// If you are changing this page size, you must also change the one for the L1 products page
// see: src/packages/spa-apps/customer-service/products/entrypoint.tsx
export const PRODUCTS_PAGE_SIZE = 50;

export const customerServiceProductsQueryResource = createRelayResource<ProductsAppQuery>({
	type: 'CUSTOMER_SERVICE_PRODUCTS_QUERY',
	getQuery: (_, { tenantContext }) => ({
		parameters: CUSTOMER_SERVICE_PRODUCTS_QUERY,
		variables: {
			cloudId: tenantContext.cloudId,
			first: PRODUCTS_PAGE_SIZE,
		},
		options: { fetchPolicy: 'network-only' },
	}),
});
